<script setup lang="ts">
import { Primitive } from 'reka-ui';

const { cols = 12 } = defineProps<{
	as?: string;
	asChild?: boolean;
	cols?: number;
}>();
</script>

<template>
	<Primitive
		:is="as"
		:as-child
		class="grid gap-2"
		:style="{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }"
	>
		<slot />
	</Primitive>
</template>
